module.exports = __webpack_public_path__ + "static/context-04cd7d7a89d50c2cfa98a36f15f3a537.png";